<template>
    <ModalConfirm
        id="modal-confirm-upload-bukti-diterima-kas-kecil"
        title="Konfirmasi Upload Bukti Diterima"
        desc="Apakah Anda yakin ingin menyimpan bukti diterima ini?"
        :isSubmitting="isSubmitting"
        @submit="$emit('submit')"
    />
</template>

<script>
export default {
    name: "modal-kas-kecil-upload-bukti-confirm",
    props: {
        isSubmitting: { type: Boolean, default: false },
    },
}
</script>
